/** Theme list row label used when resolving `themeId` for customize-invoice-template. */
export const INVOICE_TOUR_NAME_FOR_INVOICE = 'Fordeer for Invoice'
